import styled from "styled-components";
import media from "styled-media-query";

export const Wrapper = styled.div`
  background-color: rgba(38, 38, 38, 0.6);
  backdrop-filter: blur(2px);
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 100;

  transition: 0.2s;

  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? "auto" : "none")};
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.neutral.black};
  height: fit-content;
  padding: 22px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  padding-top: 40px;

  display: flex;
  flex-direction: column;
  gap: 18px;

  ${media.greaterThan("medium")`
    padding-top: 22px;
    width: fit-content;  
    height: fit-content;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    max-width: 580px;
    min-width: 500px;
  `}
`;

export const CloseButton = styled.button`
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  p {
    color: ${({ theme }) => theme.colors.neutral.white};
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  h1 {
    color: ${({ theme }) => theme.colors.neutral.white};
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
  }

  span {
    color: ${({ theme }) => theme.colors.neutral.white};
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;

  ${media.greaterThan("medium")`
    flex-direction: row;
    justify-content: flex-end;
  `}
`;
